(function(){
  function init(root){
    root.querySelectorAll('.e-track-wrap').forEach(function(w){
      if(w.dataset.ready) return; w.dataset.ready=1;
      var t=w.querySelector('.e-track');
      w.querySelectorAll('.e-arrow').forEach(function(a){
        a.addEventListener('click',function(){t.scrollBy({left:(a.classList.contains('l')?-1:1)*t.clientWidth*.8,behavior:'smooth'})});
      });
    });
    root.querySelectorAll('.e-chips a').forEach(function(a){
      a.addEventListener('click',function(){root.querySelectorAll('.e-chips a').forEach(function(x){x.classList.remove('on')});a.classList.add('on')});
    });
    root.querySelectorAll('[data-e-drawer-open]').forEach(function(b){
      b.addEventListener('click',function(){var d=document.getElementById(b.getAttribute('data-e-drawer-open'));if(d)d.classList.add('open')});
    });
    root.querySelectorAll('[data-e-drawer-close]').forEach(function(b){
      b.addEventListener('click',function(){var d=b.closest('.e-drawer');if(d)d.classList.remove('open')});
    });
  }

  function color(root){
    if(!('IntersectionObserver' in window)) return;
    if(window.matchMedia && matchMedia('(hover:hover)').matches) return;
    var rail=new IntersectionObserver(function(es){es.forEach(function(e){e.target.classList.toggle('is-color',e.isIntersecting)})},{rootMargin:'0px -22% 0px -22%',threshold:.7});
    var page=new IntersectionObserver(function(es){es.forEach(function(e){e.target.classList.toggle('is-color',e.isIntersecting)})},{threshold:.6});
    root.querySelectorAll('.e-m,.e-big,.e-hero-art').forEach(function(m){
      if(m.dataset.io||!m.querySelector('img.cv,.e-hero-img')) return; m.dataset.io=1;
      (m.closest('.e-track')?rail:page).observe(m);
      m.addEventListener('touchstart',function(){m.classList.add('is-color')},{passive:true});
    });
  }
  document.addEventListener('DOMContentLoaded',function(){init(document);color(document)});
  document.addEventListener('shopify:section:load',function(e){init(e.target);color(e.target)});
})();
/* elhartista · cuenta regresiva de lanzamiento (usa la marca de tiempo UTC: igual en cualquier zona horaria) */
(function(){
  function pad(n){return (n<10?'0':'')+n}
  function live(scope){
    if(!scope||scope.dataset.live) return; scope.dataset.live=1; scope.classList.add('is-live');
    scope.querySelectorAll('[data-pre]').forEach(function(x){x.hidden=true});
    scope.querySelectorAll('[data-post]').forEach(function(x){x.hidden=false});
    scope.querySelectorAll('[data-live-href]').forEach(function(a){a.setAttribute('href',a.getAttribute('data-live-href'))});
  }
  function tick(){
    var now=Date.now();
    document.querySelectorAll('[data-eh-cd]').forEach(function(el){
      var t=el._t; if(t===undefined){t=Date.parse(el.getAttribute('data-eh-cd'));el._t=t;}
      if(isNaN(t)) return;
      var d=Math.floor((t-now)/1000);
      if(d<=0){
        if(!el.classList.contains('is-done')){
          el.classList.add('is-done');
          el.querySelectorAll('.e-cd-u').forEach(function(u){u.hidden=true});
          var dn=el.querySelector('.e-cd-done'); if(dn) dn.hidden=false;
        }
        live(el.closest('[data-eh-launch]'));
        return;
      }
      var v={d:Math.floor(d/86400),h:Math.floor(d%86400/3600),m:Math.floor(d%3600/60),s:d%60};
      ['d','h','m','s'].forEach(function(k){var b=el.querySelector('[data-u="'+k+'"]');if(b){var s=k==='d'?String(v[k]):pad(v[k]);if(b.textContent!==s)b.textContent=s;}});
    });
  }
  function start(){tick(); if(!window.__ehCd){window.__ehCd=setInterval(tick,1000);}}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start)}else{start()}
  document.addEventListener('shopify:section:load',tick);
})();
